$(function(){
    $('.js-trigger-checkout').on('click', function(){
        $('#place_order').trigger('click');
    })
})